import React, { useEffect } from 'react';

export default function SHREEJI9() {

  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "tpjgka69hw");
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = "https://cdn.jsdelivr.net/gh/Anshluthra1/chat-widget@latest/script.js";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    // Add custom data attributes
    script.setAttribute("data-whatsapp", "919111473596");
    script.setAttribute("data-button-text", "Chat Now");
    script.setAttribute("data-position", "right");
    script.setAttribute("data-color", "#2f2e41");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render any visible UI
}
